import { useSessionAuth } from '@/context/Auth';
import { getCart } from '@/infrastructure/api/cart';
import { ValidatedCart } from '@/infrastructure/domain/cart';
import { UseQueryResult, useQuery } from '@tanstack/react-query';

export const useGetCart = (
  marketId?: string,
): UseQueryResult<ValidatedCart, Error> => {
  const { token } = useSessionAuth();

  return useQuery({
    queryKey: ['cart', marketId],
    queryFn: () =>
      // will only trigger if marketId is actually present
      getCart(token!, marketId!),
    enabled: Boolean(marketId),
  });
};
